import {css} from "@emotion/react";


export const root = css`
    color: #676767;
    background-color: transparent;
    font-size: 13px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    height: 62px;
    border: none;
    outline: none;
    padding: 0;
`;

export const rootSelected = css`
    color: #449DF7;
    background-color: white;
    border-left: 0.5px solid #C5CACE;
    border-right: 0.5px solid #C5CACE;
`;

export const topBar = css`
    height: 6px;
    width: 100%;
    background-color: transparent;
`;
export const topBarSelected = css`
    background-color: #449DF7;
`;

export const text = css`
    display: flex;
    justify-content: center;
    align-items: center;
    flex: 1;

    padding-left: 72px;
    padding-right: 72px;
`;